import {Component} from 'react'
import './index.css'

class CoinToss extends Component {
  state = {
    heads: 0,
    tails: 0,
    lastTossedResult: 0,
  }

  onClickToss = () => {
    const tossResult = Math.floor(Math.random() * 2)
    this.setState({lastTossedResult: tossResult})
    if (tossResult === 0) {
      this.setState(prevState => ({heads: prevState.heads + 1}))
    } else {
      this.setState(prevState => ({tails: prevState.tails + 1}))
    }
  }

  render() {
    const {heads, tails, lastTossedResult} = this.state
    return (
      <div className="bg-container">
        <div className="coin-toss-container">
          <h1 className="heading"> Coin Toss Game </h1>
          <p className="heads-tails"> Heads (or) Tails</p>
          {lastTossedResult === 0 ? (
            <img
              src="https://assets.ccbp.in/frontend/react-js/heads-img.png"
              className="coin-image"
              alt="toss result"
            />
          ) : (
            <img
              src="https://assets.ccbp.in/frontend/react-js/tails-img.png"
              className="coin-image"
              alt="toss result"
            />
          )}

          <button
            className="coin-toss"
            type="button"
            onClick={this.onClickToss}
          >
            Toss Coin
          </button>
          <div className="toss-result-container">
            <p className="toss-result">Total: {heads + tails}</p>
            <p className="toss-result"> Heads: {heads} </p>
            <p className="toss-result"> Tails: {tails} </p>
          </div>
        </div>
      </div>
    )
  }
}

export default CoinToss
